import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CreateParticipantTask } from '../mutations/createParticipantTask.mutation';
import type {
  CreateParticipantTaskMutation,
  CreateParticipantTaskMutationVariables,
} from '../types';

export const useCreateParticipantTaskMutation = (
  options?: MutationOptions<CreateParticipantTaskMutation, CreateParticipantTaskMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantTask), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('tasks'),
      });
    },
  });
};
